import { render, staticRenderFns } from "./r-item-addon-page.vue?vue&type=template&id=6301e0ed"
import script from "./r-item-addon-page.vue?vue&type=script&lang=js"
export * from "./r-item-addon-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6301e0ed')) {
      api.createRecord('6301e0ed', component.options)
    } else {
      api.reload('6301e0ed', component.options)
    }
    module.hot.accept("./r-item-addon-page.vue?vue&type=template&id=6301e0ed", function () {
      api.rerender('6301e0ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-addon/r-item-addon-page.vue"
export default component.exports